module.exports = __webpack_public_path__ + "static/media/downgrade.57dc5eef.svg";